module.exports = __webpack_public_path__ + "img/rchouse-calculator.e6baaaf6.svg";